import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import Navigation from "../../../../components/navigations/provider-management/detail/navigation";

export default function Template() {
  const { id } = useParams();
  const { pathname } = useLocation();

  if (pathname === `/provider/${id}/management` || pathname === `/provider/${id}/management/`) {
    return <Navigate to={`/provider/${id}/management/entity-info`} replace />;
  }

  return (
    <Navigation activeTab="management" providerId={id}>
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-y-auto rounded-b-[15px] bg-white">
        <Outlet />
      </div>
    </Navigation>
  );
}
